import React, { useState } from 'react';
import { Users, Eye, X, MapPin } from 'lucide-react';
import boothCommitteData from '../data/booth_committee.json';

function BoothCommittee() {
  const [selectedBooth, setSelectedBooth] = useState(null);
  const [showPDFViewer, setShowPDFViewer] = useState(false);

  // Sort booths by booth_number (numerically if possible)
  const sortedBooths = [...boothCommitteData].sort((a, b) => {
    // Extract booth numbers for comparison
    const boothNumA = a.booth_number ? parseInt(a.booth_number) : 0;
    const boothNumB = b.booth_number ? parseInt(b.booth_number) : 0;
    return boothNumA - boothNumB;
  });

  // Filter and sort booths
  const filteredBooths = sortedBooths.filter(booth => {
    // Check if file_name exists
    const hasFile = booth.file_name && booth.file_name.trim() !== '';
    
    
    // Only show if file exists AND matches search
    return hasFile;
  });

  const handleViewPDF = (booth) => {
    setSelectedBooth(booth);
    setShowPDFViewer(true);
  };

  const closePDFViewer = () => {
    setShowPDFViewer(false);
    setSelectedBooth(null);
  };

  return (
    <div>
      {/* Page Header */}
      <div className="bg-gradient-to-r from-orange-600 to-orange-500 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center mb-4">
            <Users className="w-10 h-10 mr-4" />
            <h1 className="text-4xl font-bold">பூத் குழு விபரங்கள்</h1>
          </div>
          <p className="text-orange-100 text-lg">
            மொத்தம் {sortedBooths.length} பூத் குழுகஂகளஂ
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        {/* Booth Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredBooths.map((booth) => (
            <div
              key={booth.id}
              className="bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden border-l-4 border-orange-500"
            >
              <div className="p-6">
                {/* Booth Number Badge */}
                {booth.booth_number && (
                  <div className="mb-4">
                    <span className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full font-bold text-sm">
                      பூத் எண்: {booth.booth_number}
                    </span>
                  </div>
                )}

                {/* Booth Name */}
                <div className="mb-4">
                  <div className="flex items-start gap-2 mb-2">
                    <MapPin className="w-5 h-5 text-orange-500 flex-shrink-0 mt-1" />
                    <h3 className="text-xl font-bold text-gray-800 leading-tight">
                      {booth.name}
                    </h3>
                  </div>
                </div>

                {/* View Button */}
                <button
                  onClick={() => handleViewPDF(booth)}
                  className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-3 rounded-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                >
                  <Eye className="w-5 h-5" />
                  குழு விபரம் பார்க்க
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* No Results */}
        {filteredBooths.length === 0 && (
          <div className="text-center py-16 bg-white rounded-lg shadow-md">
            <Users className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">பூத் கிடைக்கவில்லை</h3>
            <p className="text-gray-500">தேடல் விதிமுறைகளை மாற்றி முயற்சிக்கவும்</p>
          </div>
        )}
      </div>

      {/* PDF Viewer Modal */}
      {showPDFViewer && selectedBooth && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl h-[90vh] flex flex-col">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-t-xl">
              <div>
                <h2 className="text-2xl font-bold mb-1">{selectedBooth.name}</h2>
                {selectedBooth.booth_number && (
                  <p className="text-orange-100">பூத் எண்: {selectedBooth.booth_number}</p>
                )}
              </div>
              <button
                onClick={closePDFViewer}
                className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* PDF Viewer */}
            <div className="flex-1 overflow-hidden bg-gray-100">
              <iframe
                src={`/assets/booth_committee/${selectedBooth.file_name}`}
                className="w-full h-full border-0"
                title={`${selectedBooth.name} - Committee Details`}
              />
            </div>

            {/* Modal Footer */}
            <div className="p-4 border-t bg-gray-50 rounded-b-xl flex justify-between items-center">
              <button
                onClick={closePDFViewer}
                className="px-6 py-2 bg-gray-600 text-white rounded-lg font-semibold hover:bg-gray-700 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BoothCommittee;